import { createContext, useCallback, useContext, useRef, useState } from 'react';

const AiAssistantContext = createContext(null);

export const AiAssistantProvider = ({ children }) => {
  const [widgetOpen, setWidgetOpen] = useState(false);
  const pendingMessageRef = useRef(null);

  const openWidget = useCallback((initialMessage = '') => {
    pendingMessageRef.current = initialMessage ? String(initialMessage).trim() : null;
    setWidgetOpen(true);
  }, []);

  const closeWidget = useCallback(() => {
    setWidgetOpen(false);
  }, []);

  const toggleWidget = useCallback(() => {
    setWidgetOpen((open) => !open);
  }, []);

  const consumePendingMessage = useCallback(() => {
    const msg = pendingMessageRef.current;
    pendingMessageRef.current = null;
    return msg;
  }, []);

  return (
    <AiAssistantContext.Provider
      value={{
        widgetOpen,
        openWidget,
        closeWidget,
        toggleWidget,
        consumePendingMessage,
      }}
    >
      {children}
    </AiAssistantContext.Provider>
  );
};

export const useAiAssistant = () => {
  const ctx = useContext(AiAssistantContext);
  if (!ctx) {
    throw new Error('useAiAssistant must be used within AiAssistantProvider');
  }
  return ctx;
};

export default AiAssistantContext;
